/**
 *
 *@author zcc
 *@date 2022/3/14 9:55
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import axios from 'axios';
import { Debug } from '@/constant/Debug';
import { UrlConfig } from '@/config/UrlConfig';

export class DocViewModel extends BaseViewModel {
  markdown = '';
  isShowMenu = false;
  isPadSize = false;
  isShowMark = false;
  menuList = [];

  async created() {
    await this.getMenuList();
    if (this.$route.path.indexOf('home') > -1) {
      return;
    }
    let defaultHash: any = this.$route.hash;
    defaultHash = defaultHash ? defaultHash.replace('#', '') : 'fastStart';
    this.showMdFile(defaultHash);
    document.title = '开发与帮助文档';
  }

  mounted() {
    this.isPadSize = window.innerWidth < 799;
    window.addEventListener('resize', () => {
      this.handlerResize();
    });
  }

  unmounted() {
    document.title = '开放平台';
  }

  private getMenuList(): Promise<boolean> {
    return new Promise((resolve) => {
      if (Debug) {
        this.menuList = require('../../../public/md/menu.json');
        resolve(true);
        return;
      }
      axios.get(`${UrlConfig.markdownPath}/menu.json`).then((res) => {
        this.menuList = res.data;
        resolve(true);
      });
    });
  }

  handlerResize() {
    const val = window.innerWidth < 799;
    if (this.isPadSize === val) {
      return;
    }
    if (val != this.isPadSize && this.isPadSize) {
      this.isShowMenu = false;
      this.isPadSize = val;
      return;
    }
    this.isShowMenu = true;
    this.isPadSize = val;
  }

  controlMenuVisible() {
    if (!this.isShowMenu) {
      this.isShowMenu = true;
      this.isShowMark = true;
      return;
    }
    this.isShowMenu = false;
  }

  /**
   * 根据选中的菜单 侠士对应的文档内容
   * @param fileName
   */
  showMdFile(fileName: string) {
    // 每次打开tab 都是跳转到当前文档顶部
    const el = document.querySelector('.github-markdown-body') as HTMLElement;
    if (el) {
      el.scrollIntoView();
    }
    this.$router.push({ path: '/website/doc', hash: `#${fileName}` }).then();
    const fileSrc = `${UrlConfig.markdownPath}/${this.getMdSrc(fileName)}.md`;
    axios.get(fileSrc).then((res) => {
      this.markdown = res.data;
    });
    if (this.isPadSize) {
      this.isShowMenu = false;
    }
  }

  private getMdSrc(fileName: string) {
    let src = '';
    this.menuList.forEach((group: any) => {
      group.list.forEach((item: any) => {
        if (item.id === fileName) {
          src = `${group.id}/${item.id}`;
        }
      });
    });
    return src;
  }

  closedDrawer() {
    this.isShowMenu = false;
  }
}
